import { Component, OnInit, Injector } from '@angular/core';
import { EmbedVideoService } from '../common-theme/index';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';

@Component({
  selector: 'app-our-view',
  templateUrl: './our-view.component.html',
  styleUrls: ['./our-view.component.scss']
})

export class OurViewComponent extends SeoAwareBaseComponent implements OnInit {
  public youtubeUrl: string = 'https://www.youtube.com/watch?v=XOLGCf9AEHg';
  public videoInnerHTML: any;

  constructor(
    public injector: Injector,
    private embedService: EmbedVideoService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.videoInnerHTML = this.embedService.embed(this.youtubeUrl);

    this.setTitle('Conceptul de la baza proiectului Romanescu Park Residence');

    this.setMetaDescription(`
      Romanescu Park Residence este un proiect născut din dorința de a oferi craiovenilor toate
      necesitățile unei comunități urbane moderne și posibilitatea de a se relaxa cât mai aproape de
      natură. Unicitatea proiectului este dată de locația deosebită și de design-ul simplu și inteligent
    `);
  }
}



// WEBPACK FOOTER //
// ./src/app/downtown-life/our-view.component.ts